import React from 'react';
import AppBar from '../../components/AppBar';
import './Privacy.css';
import { FaShieldAlt } from 'react-icons/fa';
import Footer from '../../components/Footer';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <AppBar backgroundColor="#0a0a0a" />
      <div className="privacy-container">
        <div className="privacy-header">
          <FaShieldAlt className="privacy-icon" />
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              At LunaSearch, we take your privacy seriously. This Privacy Policy explains how we collect, 
              use, disclose, and safeguard your information when you use our cryptocurrency search and 
              analysis platform.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            <p>We collect information that you provide directly to us, including:</p>
            <ul>
              <li>Account information (email, username)</li>
              <li>Usage data and search queries</li>
              <li>Device and connection information</li>
              <li>Payment information (if applicable)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the collected information for various purposes:</p>
            <ul>
              <li>To provide and maintain our service</li>
              <li>To improve and personalize your experience</li>
              <li>To communicate with you about updates and changes</li>
              <li>To detect and prevent fraud or abuse</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. 
              However, no method of transmission over the Internet is 100% secure, and we cannot 
              guarantee absolute security.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Data Retention</h2>
            <p>
              We retain your information for as long as necessary to provide our services and 
              comply with legal obligations. You can request deletion of your data at any time.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to data processing</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Cookies and Tracking</h2>
            <p>
              We use cookies and similar tracking technologies to improve your browsing experience 
              and analyze our traffic. You can control cookie settings through your browser preferences.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Third-Party Services</h2>
            <p>
              We may use third-party services that collect, monitor, and analyze data. These 
              services have their own privacy policies regarding how they use such information.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Children's Privacy</h2>
            <p>
              Our service is not intended for use by children under the age of 13. We do not 
              knowingly collect personal information from children under 13.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              <a href="mailto:privacy@lunasearch.com">privacy@lunasearch.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer backgroundColor="#0a0a0a" />
    </div>
  );
};

export default Privacy;
